import {FC, PropsWithChildren} from 'react';

import SkeletonPreloader, {SkeletonPreloaderProps} from '../SkeletonPreloader';

const SkeletonFieldPreloader: FC<PropsWithChildren<SkeletonPreloaderProps>> = ({height = 44, ...props}) => (
  <SkeletonPreloader height={height} {...props} />
);

export default SkeletonFieldPreloader;
